<template>
    <div class="gh-go-to-rego" ref="button" @click="goToRego">
        REGISTER
    </div>
</template>

<script>
    import UX from '@/utils/ux';

    export default {
        mounted() {
            new ScrollMagic.Scene({
                offset: 500
            })
                .setClassToggle(this.$refs.button, 'is-active')
                .addTo(this.$root.scrollMagicController);
        },

        methods: {
            goToRego() {
                UX.scrollTo(document.querySelector('#registration'));

                this.$refs.button.className += " hide-rego-button";
            }
        }
    }
</script>

<style lang="scss" scoped>

    @media (max-width: 678px) {

        .gh-go-to-rego.is-active {
            visibility: visible;
            opacity: 1;
        }
        
    }

    .hide-rego-button {
        display:none;
    }

    .gh-go-to-rego {
        position: fixed;
        left: 1rem;
        bottom: 1rem;
        z-index: 5;
        visibility: hidden;
        border-radius: 4px;
        background: rgba(81, 74, 157, 0.85);
        opacity: 0;
        font-size: 1.5rem;
        cursor: pointer;
        transition: .5s;
        color:#fff;
        padding:5px;
    }
</style>